import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { BankAccount, UpdateBankAccountBody } from '@klopotun/contracts';
import { updateBankAccount } from '../requests/update-bank-account.js';
import { refreshBankAndCards } from './bank-cache.js';

export type UpdateBankAccountInput = { id: string; body: UpdateBankAccountBody };

const changeAccount = (input: UpdateBankAccountInput): Promise<BankAccount> =>
  updateBankAccount(input.id, input.body);

export const useUpdateBankAccountMutation = (): UseMutationResult<
  BankAccount,
  Error,
  UpdateBankAccountInput
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: changeAccount,
    onSuccess: () => refreshBankAndCards(queryClient),
  });
};
